import { SidebarIsland } from "@aurem/components";
import { cn, useBoolean, useBreakpoints } from "@aurem/ui";
import { CompanyBottomNavigation } from "components/mobile/BottomNavigation/CompanyBottomNavigation";
import { Topbar } from "components/Topbar";
import { PageTitleProvider } from "components/Topbar/PageTitle";
import { LayoutInnerSidebar } from "layouts/admin/LayoutInnerSidebar";
import { LayoutOnboardingSidebar } from "layouts/admin/LayoutOnboardingSidebar";
import { LayoutOuterSidebar } from "layouts/admin/LayoutOuterSidebar";
import { BannerProvider, BannerStack } from "providers/BannerProvider";
import { Outlet, useParams } from "react-router-dom";
import { ChatPanel } from "root/ChatPanel";

export const AdminLayout = () => {
  const { companyId } = useParams();
  const { isMobile } = useBreakpoints();

  const {
    value: showOuterSidebar,
    setTrue: openOuterSidebar,
    setFalse: closeOuterSidebar,
  } = useBoolean();

  const showBottomNavigation = !!companyId && isMobile;

  return (
    <div className="flex flex-col sm:flex-row flex-grow min-h-0 bg-neutral-500/5 sm:gap-2 sm:p-2">
      <SidebarIsland>
        <LayoutOuterSidebar
          open={showOuterSidebar}
          onClose={closeOuterSidebar}
        />
        {!isMobile && <LayoutInnerSidebar />}
      </SidebarIsland>
      <div className="flex flex-1 min-w-0 min-h-0 overflow-hidden bg-background-500 sm:rounded-[1.25rem] sm:shadow-lg">
        {!isMobile && <LayoutOnboardingSidebar />}
        <PageTitleProvider>
          <BannerProvider>
            <div
              className="relative flex flex-col grow min-w-0 min-h-0 overflow-y-hidden w-full"
              style={{ maxHeight: "100dvh" }}
            >
              <Topbar openOuterSidebar={openOuterSidebar} />
              <div className="flex flex-col grow min-h-0 overflow-hidden w-full relative">
                <BannerStack />
                <div
                  className={cn(
                    "flex flex-col flex-1 min-h-0 overflow-auto",
                    showBottomNavigation &&
                      "pb-[calc(5rem_+_env(safe-area-inset-bottom))]",
                  )}
                >
                  <Outlet />
                </div>
                <ChatPanel />
              </div>
              {showBottomNavigation && <CompanyBottomNavigation />}
            </div>
          </BannerProvider>
        </PageTitleProvider>
      </div>
    </div>
  );
};
